import React from 'react';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import vendorConfig from './config/vendorConfig';
import setViewTitle from '../../helpers/setViewTitle';
import SimplePage from '../common/SimplePage';
import { Form, Input, FormRow } from '../common/Forms';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var Vendor = createReactClass({

  componentWillMount() {
    setViewTitle('Neuer Lieferant');
  },

  submitForm(newVendor) {
    request.post({
      url: vendorConfig.apiUrl,
      data: newVendor,
      success: () => {
        this.props.history.push(`/vendors`);
      }
    });
  },

  componentDidMount() {
    this.form.focus('name');
  },

  render() {
    return (
      <SimplePage title="Neuer Lieferant" icon="paper-plane">
        <Form
          ref={c => this.form = c}
          onSubmit={this.submitForm}
          isAjaxInProgress={this.props.isAjaxInProgress}
          backButtonLink="/vendors">

          <fieldset>
            <FormRow width={6}>
              <Input
                layout="vertical"
                name="name"
                id="name"
                label="Name:"
                type="text"
                required
              />
            </FormRow>
          </fieldset>

        </Form>
      </SimplePage>
    );
  }

});

export default AjaxInProgressHOC(Vendor);



// WEBPACK FOOTER //
// ./src/components/vendors/NewVendor.js